<div class="upload z-fx-col z-fx-gap-8" [class.disabled]="disabled">
  <zef-drag-zone
    [class.inactive]="mode !== 'file' && !uploading && !hovering && file"
    [class.loading]="uploading"
    [class.round]="isLarge"
    [ngClass]="[size, shape || '']"
    [active]="active"
    (zoneActive)="hovering = $event"
    (zoneDrop)="onZoneDrop($event)"
    (zoneDragStart)="dropping = true"
    (zoneDragEnd)="dropping = false"
    (click)="!uploading && !disableClick && fileInput.click()"
  >
    @if (file && mode !== 'file' && !uploading && imageSrc) {
      <img
        [src]="imageSrc"
        class="upload-image"
        [ngClass]="fit"
        [class.landscape]="imgEl.height > imgEl.width"
        [class.portrait]="imgEl.height < imgEl.width"
        [class.team-avatar-cover]="useCover"
        [class.team-avatar-contain]="useContain"
        (load)="onImageLoad()"
        alt="upload"
        #imgEl
      />
    }

    <div class="z-fx-col z-fx-center-center z-fx-gap-16 zef-text-overflow-line upload-content">
      @if (uploading) {
        <zef-spinner
          [mode]="!progress || progress === 1 ? 'indeterminate' : 'determinate'"
          [progress]="progress"
          [size]="isLarge ? 'large' : 'larger'"
        ></zef-spinner>
        @if (mode === 'file' && fileName) {
          <div>
            {{ fileName }}
          </div>
        }
      } @else {
        @if (hovering) {
          <ng-container [ngTemplateOutlet]="nullOrHoverTmpl"></ng-container>
        } @else {
          @if (error) {
            <mat-icon color="alert" [class.zef-icon-larger]="isLarger" [class.zef-icon-large]="isLarge">
              bullet_alert
            </mat-icon>
            @if (mode === 'file') {
              <div class="zef-color-alert">
                @if (fileName) {
                  {{ fileName }}
                }
                @if (!fileName) {
                  <ng-container i18n>No file found...</ng-container>
                }
              </div>
            }
          } @else {
            @if (file) {
              @if (mode === 'file') {
                <mat-icon color="ink" class="zef-icon-larger">bullet_check</mat-icon>
                <div class="zef-color-ink">
                  {{ fileName }}
                </div>
              }
            } @else {
              <ng-container *ngTemplateOutlet="nullOrHoverTmpl"></ng-container>
            }
          }
        }
      }
    </div>
  </zef-drag-zone>

  @if (error && error !== true) {
    <div class="zef-color-alert zef-text-p1">
      <ng-container [ngTemplateOutlet]="error"></ng-container>
    </div>
  }
</div>

<input class="upload-input" type="file" (change)="onFileInputChange(fileInput)" #fileInput />

<ng-template #nullOrHoverTmpl>
  @if (mode === 'file') {
    <mat-icon class="zef-icon-larger">upload</mat-icon>
  }
  @if (mode === 'upload') {
    <mat-icon class="zef-icon-large">upload</mat-icon>
  }
  @if (mode === 'image') {
    <mat-icon class="zef-icon-larger">drag</mat-icon>
  }
  @if (mode === 'avatar') {
    <mat-icon class="zef-icon-large">photo_new</mat-icon>
  }
  @if (mode === 'team') {
    <mat-icon class="zef-icon-larger">upload</mat-icon>
  }
  @if (showText && !size.startsWith('small')) {
    <div class="zef-text-overflow-line" i18n>Drag here or click to browse...</div>
  }
</ng-template>
